import React from "react";

export const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative px-6 sm:px-10 py-16 sm:py-20"
      style={{ background: "var(--kz-bg)", borderTop: "1px solid var(--kz-border)" }}
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-12 gap-10 items-start">
          <div className="md:col-span-5">
            <div
              className="font-display font-extrabold text-3xl sm:text-4xl tracking-tight"
              style={{ color: "var(--kz-text-primary)" }}
            >
              KZ <span style={{ color: "var(--kz-accent)" }}>Environmental</span>
            </div>
            <p
              className="mt-4 text-sm leading-relaxed max-w-sm"
              style={{ color: "var(--kz-text-secondary)" }}
            >
              Commercial Waste · Recycling · Pressure Washing · Site Services
            </p>
          </div>

          <div className="md:col-span-4">
            <div
              className="font-display text-[11px] uppercase tracking-[0.3em] mb-3"
              style={{ color: "var(--kz-text-secondary)", opacity: 0.7 }}
            >
              Contact
            </div>
            <a
              data-testid="footer-email"
              href="mailto:service@kzenvironmental.com"
              className="font-display text-base hover:underline underline-offset-4"
              style={{ color: "var(--kz-accent)" }}
            >
              service@kzenvironmental.com
            </a>
          </div>

          <div className="md:col-span-3 md:text-right">
            <div
              className="font-display text-[11px] uppercase tracking-[0.3em] mb-3"
              style={{ color: "var(--kz-text-secondary)", opacity: 0.7 }}
            >
              Service
            </div>
            <div
              className="font-display text-sm"
              style={{ color: "var(--kz-text-secondary)" }}
            >
              Commercial · Industrial
            </div>
          </div>
        </div>

        <div className="section-rule mt-14 mb-8" />

        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <span
            className="font-display text-xs uppercase tracking-[0.3em]"
            style={{ color: "var(--kz-text-secondary)", opacity: 0.6 }}
          >
            © {new Date().getFullYear()} KZ Environmental — All Rights Reserved
          </span>
          <span
            className="font-display text-xs uppercase tracking-[0.3em]"
            style={{ color: "var(--kz-text-secondary)", opacity: 0.6 }}
          >
            Commercial Services
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
